import React, { useEffect, useState } from "react";
import Dropdown from "components/dropdown";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import avatar from "assets/img/avatars/avatar4.png";
import { getUserDetails } from "services/common";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../store/authSlice";
import { FaBars } from "react-icons/fa";
import axios from "axios";

const Navbar = (props) => {
  const { brandText } = props;
  const { onOpenSidenav } = props;
  const [darkmode, setDarkmode] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const token =
    useSelector((state) => state.auth.token) || localStorage.getItem("token");
  const [darkmode1, setDarkmode1] = useState(
    localStorage.getItem("darktheme") === "true" // convert string → boolean
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUserDetails(token);
        setUserDetails(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [authState.isAuthenticated, navigate]);

  useEffect(() => {
    if (darkmode1) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    localStorage.setItem("darktheme", darkmode1.toString()); // store as "true"/"false"
  }, [darkmode1]);

  const handleLogout = async () => {
    try {
      // Convert system time to IST
      const istLogoutTime = new Date(
        new Date().getTime() + 5.5 * 60 * 60 * 1000
      )
        .toISOString()
        .replace("Z", "+05:30");

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/logout`,
        {
          logoutTime: istLogoutTime,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Logout API failed:", error);
    } finally {
      dispatch(logout());
      localStorage.removeItem("token");
      navigate("/auth/sign-in");
    }
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <FaBars
        onClick={onOpenSidenav}
        className="mx-2 cursor-pointer text-2xl dark:text-white xl:hidden"
      />
      <div className="ml-[6px] ">
        <p className="mr-4 shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            // to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>
      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[110px] md:flex-grow-0 md:gap-1 xl:w-[105px] xl:gap-2">
        {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search... abhi"
            class="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div> */}

        <div
          className="cursor-pointer text-gray-600"
          onClick={() => setDarkmode1((prev) => !prev)}
        >
          {darkmode1 ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 cursor-pointer rounded-full"
              src={avatar}
              alt="Elon Musk"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none ">
              <div className="cursor-pointer p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {userDetails?.name}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col rounded-lg bg-white p-6 shadow-md dark:bg-navy-800">
                <button
                  className="mb-4 rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 ease-in-out hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                  onClick={() => navigate("/admin/profile")}
                >
                  Profile
                </button>

                <button
                  onClick={handleLogout}
                  className="rounded-lg bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 ease-in-out hover:bg-red-600"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
